import { Controller } from "@hotwired/stimulus"

// A checkbox that reveals a panel of inputs. The panel's inputs are disabled
// while hidden so an unticked box submits none of them.
//
//   <div data-controller="checkbox-panel">
//     <input type="checkbox" data-checkbox-panel-target="checkbox"
//            data-action="change->checkbox-panel#refresh">
//     <div data-checkbox-panel-target="panel">…inputs…</div>
//   </div>
export default class extends Controller<HTMLElement> {
  static targets = ["checkbox", "panel"]

  declare readonly checkboxTarget: HTMLInputElement
  declare readonly panelTarget: HTMLElement

  connect() {
    this.refresh()
  }

  refresh() {
    const on = this.checkboxTarget.checked
    this.panelTarget.classList.toggle("hidden", !on)
    this.panelTarget
      .querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>("input, select, textarea")
      .forEach((field) => { field.disabled = !on })
  }
}
